const TERRA_AUTH_CALLBACK_HOST = 'terra-auth-callback'

type TerraAuthResult = { type: 'success'; url?: string } | { type: 'cancel' | 'dismiss' }

type TerraAuthResultHandlers = {
  onSuccess: () => void
  onFailure: (reason?: string) => void
  onCancel: () => void
}

// Terra's failure redirect carries `error_code` (e.g. invalid_credentials); older flows used `reason`
const TERRA_AUTH_FAILURE_PARAMS = [/[?&]error_code=([^&#]*)/, /[?&]reason=([^&#]*)/]
const TERRA_AUTH_INVALID_LOGIN_CODES = ['invalid_credentials', 'invalid_username']

export const getTerraAuthRedirectUrl = (scheme: string) => `${scheme}://${TERRA_AUTH_CALLBACK_HOST}`

export const getTerraAuthCallbackFailureReason = (callbackUrl: string) => {
  const encodedReason = TERRA_AUTH_FAILURE_PARAMS.map(
    (param) => callbackUrl.match(param)?.[1],
  ).find(Boolean)

  if (!encodedReason) {
    return
  }

  try {
    return decodeURIComponent(encodedReason.replace(/\+/g, ' '))
  } catch {
    return encodedReason
  }
}

const hasTerraAuthCallbackResource = (callbackUrl: string) =>
  /[?&]resource=([^&#]+)/.test(callbackUrl)

export const getTerraAuthFailureMessage = (displayName: string, reason?: string) =>
  reason && TERRA_AUTH_INVALID_LOGIN_CODES.includes(reason)
    ? `Couldn't connect ${displayName}. Check your login details and try again.`
    : `Couldn't connect ${displayName}. Please try again.`

export const handleTerraAuthResult = (
  result: TerraAuthResult,
  { onSuccess, onFailure, onCancel }: TerraAuthResultHandlers,
) => {
  if (result.type !== 'success') {
    onCancel()
    return
  }

  const failureReason = result.url && getTerraAuthCallbackFailureReason(result.url)

  if (!result.url || !hasTerraAuthCallbackResource(result.url) || failureReason) {
    onFailure(failureReason || undefined)
    return
  }

  onSuccess()
}
